export const CodeBookChapterFragment = gql`
  fragment CodeBookChapterFragment on CodeBookChapter {
    id
    title
    description
  }
`
